// GENERATED by sim/export_game.py — do not edit by hand.
// The Python modules in the Urvara folder are the source of truth:
// crops.py, prices.py, markets.py, competition.py, planner.py.
// Regenerate with:  python3 -I sim/export_game.py

export type Crop = {
  id: string; name: string; family: string; method: string;
  sowLo: number; sowHi: number; prop: number; grow: number; harv: number;
  yieldKgM2: number; price: number; plantsM2: number; protected: boolean;
  cuts: number; nFixer: boolean; note: string;
  priceIndex: number[]; ukShare: number[];
};
export type Channel = { id: string; name: string; mult: number;
  capPer1000: number; elasticity: number; note: string };

export const DATA = {
 "frost": {
  "last": 20,
  "first": 42
 },
 "familyGap": {
  "Allium": 3,
  "Brassica": 3,
  "Solanaceae": 4,
  "Legume": 2,
  "Umbellifer": 2,
  "Cucurbit": 2,
  "Asteraceae": 1,
  "Chenopod": 2,
  "Poaceae": 1,
  "Fungi": 0,
  "Perennial": 0
 },
 "months": [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
 ],
 "crops": [
  {
   "id": "salad",
   "name": "Salad leaves",
   "family": "Asteraceae",
   "method": "direct",
   "sowLo": 10,
   "sowHi": 34,
   "prop": 0,
   "grow": 5,
   "harv": 4,
   "yieldKgM2": 3.2,
   "price": 7.0,
   "plantsM2": 100,
   "protected": false,
   "cuts": 3,
   "nFixer": false,
   "note": "Multi-cut. The cash engine of a market garden; winter crops need protection",
   "priceIndex": [
    1.55,
    1.6,
    1.5,
    1.25,
    1.0,
    0.85,
    0.8,
    0.8,
    0.9,
    1.1,
    1.4,
    1.55
   ],
   "ukShare": [
    0.15,
    0.15,
    0.25,
    0.5,
    0.8,
    0.95,
    0.95,
    0.95,
    0.9,
    0.7,
    0.3,
    0.15
   ]
  },
  {
   "id": "salad_p",
   "name": "Salad leaves (protected)",
   "family": "Asteraceae",
   "method": "direct",
   "sowLo": 4,
   "sowHi": 40,
   "prop": 0,
   "grow": 5,
   "harv": 5,
   "yieldKgM2": 4.0,
   "price": 9.0,
   "plantsM2": 100,
   "protected": true,
   "cuts": 3,
   "nFixer": false,
   "note": "Tunnel extends both ends; winter salad hits the import-gap price window",
   "priceIndex": [
    1.55,
    1.6,
    1.5,
    1.25,
    1.0,
    0.85,
    0.8,
    0.8,
    0.9,
    1.1,
    1.4,
    1.55
   ],
   "ukShare": [
    0.15,
    0.15,
    0.25,
    0.5,
    0.8,
    0.95,
    0.95,
    0.95,
    0.9,
    0.7,
    0.3,
    0.15
   ]
  },
  {
   "id": "spinach",
   "name": "Spinach / chard",
   "family": "Chenopod",
   "method": "direct",
   "sowLo": 10,
   "sowHi": 32,
   "prop": 0,
   "grow": 7,
   "harv": 8,
   "yieldKgM2": 3.0,
   "price": 5.5,
   "plantsM2": 25,
   "protected": false,
   "cuts": 3,
   "nFixer": false,
   "note": "Hardy; overwinters under fleece in Glasgow",
   "priceIndex": [
    1.35,
    1.4,
    1.35,
    1.15,
    1.0,
    0.9,
    0.85,
    0.85,
    0.95,
    1.05,
    1.25,
    1.35
   ],
   "ukShare": [
    0.25,
    0.25,
    0.35,
    0.6,
    0.85,
    0.95,
    0.95,
    0.95,
    0.9,
    0.75,
    0.4,
    0.25
   ]
  },
  {
   "id": "herbs",
   "name": "Fresh herbs",
   "family": "Asteraceae",
   "method": "transplant",
   "sowLo": 8,
   "sowHi": 30,
   "prop": 4,
   "grow": 6,
   "harv": 10,
   "yieldKgM2": 2.0,
   "price": 14.0,
   "plantsM2": 25,
   "protected": true,
   "cuts": 4,
   "nFixer": false,
   "note": "Very strong import gap. High value per m2, labour-heavy",
   "priceIndex": [
    1.4,
    1.4,
    1.3,
    1.15,
    1.0,
    0.95,
    0.9,
    0.9,
    0.95,
    1.1,
    1.3,
    1.4
   ],
   "ukShare": [
    0.2,
    0.2,
    0.3,
    0.5,
    0.75,
    0.85,
    0.9,
    0.9,
    0.85,
    0.65,
    0.35,
    0.2
   ]
  },
  {
   "id": "radish",
   "name": "Radish",
   "family": "Brassica",
   "method": "direct",
   "sowLo": 10,
   "sowHi": 36,
   "prop": 0,
   "grow": 4,
   "harv": 2,
   "yieldKgM2": 1.8,
   "price": 4.5,
   "plantsM2": 150,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Fastest catch crop; fills gaps between main crops",
   "priceIndex": [
    1.3,
    1.3,
    1.2,
    1.1,
    1.0,
    0.9,
    0.85,
    0.85,
    0.95,
    1.05,
    1.2,
    1.3
   ],
   "ukShare": [
    0.2,
    0.22,
    0.35,
    0.6,
    0.85,
    0.95,
    0.95,
    0.95,
    0.9,
    0.7,
    0.35,
    0.22
   ]
  },
  {
   "id": "kale",
   "name": "Kale",
   "family": "Brassica",
   "method": "transplant",
   "sowLo": 16,
   "sowHi": 26,
   "prop": 5,
   "grow": 10,
   "harv": 20,
   "yieldKgM2": 3.5,
   "price": 4.0,
   "plantsM2": 4,
   "protected": false,
   "cuts": 6,
   "nFixer": false,
   "note": "Frost-hardy, harvestable through a Scottish winter",
   "priceIndex": [
    1.2,
    1.25,
    1.2,
    1.05,
    0.95,
    0.9,
    0.9,
    0.9,
    0.95,
    1.0,
    1.1,
    1.15
   ],
   "ukShare": [
    0.85,
    0.82,
    0.75,
    0.6,
    0.55,
    0.6,
    0.7,
    0.8,
    0.9,
    0.92,
    0.9,
    0.88
   ]
  },
  {
   "id": "cabbage",
   "name": "Cabbage",
   "family": "Brassica",
   "method": "transplant",
   "sowLo": 12,
   "sowHi": 26,
   "prop": 5,
   "grow": 14,
   "harv": 6,
   "yieldKgM2": 5.0,
   "price": 2.2,
   "plantsM2": 4,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Reliable bulk; needs insect mesh against cabbage root fly",
   "priceIndex": [
    1.15,
    1.2,
    1.2,
    1.1,
    1.0,
    0.95,
    0.9,
    0.9,
    0.9,
    0.95,
    1.05,
    1.1
   ],
   "ukShare": [
    0.8,
    0.78,
    0.72,
    0.6,
    0.55,
    0.65,
    0.8,
    0.9,
    0.95,
    0.95,
    0.9,
    0.85
   ]
  },
  {
   "id": "leek",
   "name": "Leeks",
   "family": "Allium",
   "method": "transplant",
   "sowLo": 8,
   "sowHi": 12,
   "prop": 12,
   "grow": 18,
   "harv": 16,
   "yieldKgM2": 3.0,
   "price": 3.2,
   "plantsM2": 16,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Long occupancy: ties a bed for most of the year",
   "priceIndex": [
    1.15,
    1.25,
    1.3,
    1.2,
    1.05,
    1.0,
    1.0,
    1.0,
    0.95,
    0.95,
    1.05,
    1.1
   ],
   "ukShare": [
    0.85,
    0.82,
    0.7,
    0.45,
    0.3,
    0.3,
    0.4,
    0.6,
    0.8,
    0.9,
    0.9,
    0.88
   ]
  },
  {
   "id": "onion",
   "name": "Onions (sets)",
   "family": "Allium",
   "method": "tuber",
   "sowLo": 12,
   "sowHi": 16,
   "prop": 0,
   "grow": 18,
   "harv": 3,
   "yieldKgM2": 3.5,
   "price": 2.0,
   "plantsM2": 36,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Sets beat seed for reliability in a wet west climate",
   "priceIndex": [
    1.15,
    1.25,
    1.3,
    1.3,
    1.2,
    1.05,
    0.9,
    0.85,
    0.85,
    0.9,
    1.0,
    1.1
   ],
   "ukShare": [
    0.7,
    0.65,
    0.55,
    0.45,
    0.35,
    0.3,
    0.45,
    0.7,
    0.85,
    0.88,
    0.82,
    0.76
   ]
  },
  {
   "id": "garlic",
   "name": "Garlic",
   "family": "Allium",
   "method": "tuber",
   "sowLo": 42,
   "sowHi": 46,
   "prop": 0,
   "grow": 34,
   "harv": 3,
   "yieldKgM2": 1.2,
   "price": 9.0,
   "plantsM2": 10,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Autumn-planted, 240-day lock-up. High-value import replacement",
   "priceIndex": [
    1.15,
    1.25,
    1.3,
    1.3,
    1.25,
    1.1,
    0.95,
    0.9,
    0.95,
    1.0,
    1.05,
    1.1
   ],
   "ukShare": [
    0.04,
    0.04,
    0.03,
    0.03,
    0.03,
    0.05,
    0.12,
    0.15,
    0.14,
    0.1,
    0.07,
    0.05
   ]
  },
  {
   "id": "carrot",
   "name": "Carrots",
   "family": "Umbellifer",
   "method": "direct",
   "sowLo": 14,
   "sowHi": 26,
   "prop": 0,
   "grow": 13,
   "harv": 6,
   "yieldKgM2": 4.0,
   "price": 2.4,
   "plantsM2": 100,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Needs a fine seedbed and mesh against carrot fly",
   "priceIndex": [
    1.2,
    1.3,
    1.35,
    1.3,
    1.15,
    1.0,
    0.9,
    0.85,
    0.8,
    0.85,
    1.0,
    1.1
   ],
   "ukShare": [
    0.9,
    0.88,
    0.8,
    0.65,
    0.5,
    0.55,
    0.8,
    0.95,
    0.98,
    0.98,
    0.95,
    0.92
   ]
  },
  {
   "id": "potato",
   "name": "Potatoes (Sarpo)",
   "family": "Solanaceae",
   "method": "tuber",
   "sowLo": 12,
   "sowHi": 18,
   "prop": 0,
   "grow": 14,
   "harv": 4,
   "yieldKgM2": 3.5,
   "price": 1.6,
   "plantsM2": 4,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Blight-resistant varieties. Blight is the main organic risk in the wet west",
   "priceIndex": [
    1.15,
    1.25,
    1.35,
    1.4,
    1.45,
    1.4,
    1.1,
    0.9,
    0.8,
    0.8,
    0.9,
    1.05
   ],
   "ukShare": [
    0.85,
    0.85,
    0.8,
    0.7,
    0.55,
    0.45,
    0.7,
    0.95,
    0.98,
    0.98,
    0.95,
    0.9
   ]
  },
  {
   "id": "squash",
   "name": "Squash / pumpkin",
   "family": "Cucurbit",
   "method": "transplant",
   "sowLo": 16,
   "sowHi": 18,
   "prop": 4,
   "grow": 16,
   "harv": 3,
   "yieldKgM2": 2.8,
   "price": 2.0,
   "plantsM2": 1,
   "protected": false,
   "cuts": 1,
   "nFixer": false,
   "note": "Stores for months, which smooths the autumn glut",
   "priceIndex": [
    1.3,
    1.35,
    1.3,
    1.1,
    1.0,
    1.0,
    1.0,
    1.0,
    0.85,
    0.8,
    0.95,
    1.15
   ],
   "ukShare": [
    0.55,
    0.45,
    0.3,
    0.15,
    0.1,
    0.1,
    0.15,
    0.4,
    0.85,
    0.95,
    0.85,
    0.7
   ]
  },
  {
   "id": "tomato",
   "name": "Tomatoes (protected)",
   "family": "Solanaceae",
   "method": "transplant",
   "sowLo": 6,
   "sowHi": 10,
   "prop": 8,
   "grow": 10,
   "harv": 14,
   "yieldKgM2": 12.0,
   "price": 4.5,
   "plantsM2": 2.5,
   "protected": true,
   "cuts": 10,
   "nFixer": false,
   "note": "Biggest UK import gap, worst Glasgow economics: light and heat both poor",
   "priceIndex": [
    1.7,
    1.7,
    1.55,
    1.3,
    1.05,
    0.9,
    0.8,
    0.75,
    0.85,
    1.1,
    1.45,
    1.65
   ],
   "ukShare": [
    0.02,
    0.03,
    0.08,
    0.25,
    0.55,
    0.75,
    0.85,
    0.85,
    0.7,
    0.4,
    0.1,
    0.03
   ]
  },
  {
   "id": "chilli",
   "name": "Chillies (protected)",
   "family": "Solanaceae",
   "method": "transplant",
   "sowLo": 4,
   "sowHi": 8,
   "prop": 10,
   "grow": 14,
   "harv": 10,
   "yieldKgM2": 4.0,
   "price": 9.0,
   "plantsM2": 3,
   "protected": true,
   "cuts": 8,
   "nFixer": false,
   "note": "Sauces add value and shelf life; seconds become product",
   "priceIndex": [
    1.25,
    1.25,
    1.2,
    1.15,
    1.05,
    0.95,
    0.9,
    0.85,
    0.85,
    0.95,
    1.1,
    1.2
   ],
   "ukShare": [
    0.05,
    0.05,
    0.05,
    0.1,
    0.15,
    0.25,
    0.4,
    0.55,
    0.55,
    0.35,
    0.15,
    0.08
   ]
  },
  {
   "id": "pea",
   "name": "Peas (combining)",
   "family": "Legume",
   "method": "direct",
   "sowLo": 10,
   "sowHi": 16,
   "prop": 0,
   "grow": 16,
   "harv": 2,
   "yieldKgM2": 0.4,
   "price": 0.32,
   "plantsM2": 80,
   "protected": false,
   "cuts": 1,
   "nFixer": true,
   "note": "Feeds the protein fractionation line",
   "priceIndex": [
    1.05,
    1.08,
    1.1,
    1.12,
    1.14,
    1.15,
    1.05,
    0.9,
    0.88,
    0.92,
    0.98,
    1.02
   ],
   "ukShare": [
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9,
    0.9
   ]
  },
  {
   "id": "mushroom",
   "name": "Oyster mushrooms",
   "family": "Fungi",
   "method": "indoor",
   "sowLo": 1,
   "sowHi": 52,
   "prop": 3,
   "grow": 2,
   "harv": 3,
   "yieldKgM2": 24.0,
   "price": 8.0,
   "plantsM2": 0,
   "protected": true,
   "cuts": 3,
   "nFixer": false,
   "note": "Continuous 6-week cycle, no season. The reason the lead project is weatherproof",
   "priceIndex": [
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0
   ],
   "ukShare": [
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55,
    0.55
   ]
  }
 ],
 "channels": [
  {
   "id": "farmgate",
   "name": "Farm gate / direct",
   "mult": 1.0,
   "capPer1000": 0.6,
   "elasticity": -0.45,
   "note": "Best price, almost no volume. Everyone starts here and nobody stays"
  },
  {
   "id": "vegbox",
   "name": "Veg box / CSA",
   "mult": 0.85,
   "capPer1000": 4.0,
   "elasticity": -0.55,
   "note": "Customers pay upfront: working capital and guaranteed demand"
  },
  {
   "id": "restaurant",
   "name": "Restaurants",
   "mult": 0.9,
   "capPer1000": 3.0,
   "elasticity": -0.6,
   "note": "Pays for novelty and reliability; drops you instantly if you miss a delivery"
  },
  {
   "id": "indie",
   "name": "Independent retail",
   "mult": 0.7,
   "capPer1000": 8.0,
   "elasticity": -0.7,
   "note": "Steady and unglamorous; needs labelling and invoicing"
  },
  {
   "id": "wholesale",
   "name": "Wholesale",
   "mult": 0.5,
   "capPer1000": 1000000000.0,
   "elasticity": -1.0,
   "note": "Absorbs everything at half price. The floor under a glut"
  },
  {
   "id": "supermarket",
   "name": "Supermarket",
   "mult": 0.45,
   "capPer1000": 1000000000.0,
   "elasticity": -1.0,
   "note": "Unlimited volume, thin margin, audit and packing capital required"
  }
 ],
 "start": {
  "cash": 2500.0,
  "assets": [
   {
    "id": "LAND-NODIG",
    "qty": 4,
    "desc": "no-dig bed, 100 m² each"
   },
   {
    "id": "STR-POLY-SM",
    "qty": 1,
    "desc": "polytunnel, 6 × 14 m"
   },
   {
    "id": "HT-SPADE",
    "qty": 1,
    "desc": "spade"
   },
   {
    "id": "HT-BROADFORK",
    "qty": 1,
    "desc": "broadfork"
   },
   {
    "id": "HT-HOE-OSC",
    "qty": 1,
    "desc": "oscillating hoe"
   },
   {
    "id": "HT-WHEELBARROW",
    "qty": 1,
    "desc": "wheelbarrow"
   },
   {
    "id": "HT-WATERCAN",
    "qty": 2,
    "desc": "watering can"
   },
   {
    "id": "INF-IBC",
    "qty": 1,
    "desc": "water store, 1,000 L"
   },
   {
    "id": "MED-COMPOST-BULK",
    "qty": 4,
    "desc": "tonne of compost"
   },
   {
    "id": "SP-SEED-PACKET",
    "qty": 12,
    "desc": "packet of starter seed"
   }
  ]
 },
 "labour": {
  "bedprep": 0.015,
  "compost": 0.01,
  "sow": 0.003,
  "water": 0.0008,
  "weedPass": 0.012,
  "harvestHrKg": 0.08,
  "packHrKg": 0.05,
  "overhead": 1.2,
  "rate": 16.5
 }
} as const;

export const CROPS: readonly Crop[] = DATA.crops as unknown as Crop[];
export const CHANNELS: readonly Channel[] = DATA.channels as unknown as Channel[];
